import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "curriculum-overview",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-overview" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
